// src/components/CategoryForm.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';

const CategoryForm = ({ category, onCategoryAdded, onCategoryUpdated, onAlert }) => {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [image, setImage] = useState(null);
  const [imageUrl, setImageUrl] = useState('');

  useEffect(() => {
    if (category) {
      setName(category.name);
      setDescription(category.description);
      setImageUrl(category.image);
    }
  }, [category]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('name', name);
    formData.append('description', description);
    if (image) {
      formData.append('image', image);
    }

    try {
      if (category) {
        await axios.put(`https://royaleva.hxbindia.com/categories/${category._id}`, formData);
        onCategoryUpdated();
        onAlert('Category updated successfully!', 'success');
      } else {
        const response = await axios.post('https://royaleva.hxbindia.com/categories', formData);
        onCategoryAdded(response.data);
        onAlert('Category created successfully!', 'success');
      }
    } catch (error) {
      console.error('Error:', error);
      onAlert('Error performing action.', 'danger');
    }
  };

  return (
    <>

    <div className="container d-flex justify-content-center ">
      <div className="col-md-7 pt-5">
      <h1 className='text-info mb-5'>Manage Categories</h1>
    <form onSubmit={handleSubmit} className="mb-3">
      <div className=" mb-3">
        <label className="form-label">Name</label>
        <input
          type="text"
          className="form-control"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
        />
      </div>
      <div className="mb-3">
        <label className="form-label">Description</label>
        <textarea
          className="form-control"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          required
        ></textarea>
      </div>
      <div className="mb-3">
        <label className="form-label">Image</label>
        <input type="file" className="form-control" onChange={(e) => setImage(e.target.files[0])} />
      </div>
      {imageUrl && (
        <div className="mb-3">
          <img src={`https://royaleva.hxbindia.com/${imageUrl}`} alt="Category" className="img-fluid" style={{ maxWidth: '200px' }} />
        </div>
      )}
      <button type="submit" className="btn btn-info">{category ? 'Update' : 'Add'} Category</button>
    </form>
    </div>
    </div>
    </>
  );
};

export default CategoryForm;
